import type { Epic } from 'Flux/index.js'
import { organizationSlice } from 'Flux/Slice/Organization/OrganizationSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'

export const UpdateOrganizationMemberEpic: Epic = (action$, state$, { [organizationSlice.name]: organization, OrganizationRepository }) =>
  action$.pipe(
    filter(organization.updateOrganizationMemberRequest.match),
    mergeMap((action) => {
      return OrganizationRepository.updateOrganizationMember({
        organizationId: action.payload.organizationId,
        memberId: action.payload.memberId,
        isAdmin: action.payload.isAdmin,
        isContact: action.payload.isContact
      }).pipe(
        mergeMap((response) =>
          of(
            organization.updateOrganizationMemberSuccess({
              organizationId: action.payload.organizationId,
              user: response
            })
          )
        ),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(organization.updateOrganizationMemberFailure({ error }))
          })
        )
      )
    })
  )
